import React from "react";
import { AiOutlineArrowUp } from "react-icons/ai";
import { BiSearch } from "react-icons/bi";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { BiSolidMessageRoundedEdit } from "react-icons/bi";
import { FaDonate } from "react-icons/fa";
import { RiFundsBoxFill } from "react-icons/ri";
import { MdOutlineRequestPage } from "react-icons/md";
import { AiFillHeart } from "react-icons/ai";
import { Modal, Button, Form } from "react-bootstrap";
import axiosInstance from "../../Axois/Axois";
import toast from "react-hot-toast";
const Header = ({ borrowers = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedLoan, setSelectedLoan] = useState("");
  const [scrollPosition, setScrollPosition] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const token = localStorage.getItem("useToken");

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Argentina",
    "Australia",
    "Austria",
    "Bangladesh",
    "Belgium",
    "Brazil",
    "Canada",
    "China",
    "Denmark",
    "Egypt",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Japan",
    "Jordan",
    "Kenya",
    "Kuwait",
    "Lebanon",
    "Libya",
    "Malaysia",
    "Mexico",
    "Morocco",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine State",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Russia",
    "Saudi Arabia",
    "Singapore",
    "South Africa",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "Sweden",
    "Switzerland",
    "Syria",
    "Thailand",
    "Turkey",
    "UAE",
    "UK",
    "US",
    "Vietnam",
    "Yemen",
    "Zimbabwe",
  ];

  // ✅ Add borrower_id in formData for controlled select
  const [formData, setFormData] = useState({
    borrower_id: "",
    name: "",
    email: "",
    contact: "",
    city: "",
    country: "",
    total: "",
    payment_method: "stripe",
  });

  // ✅ donation details (used for backend payload)
  const [donationDetails, setDonationDetails] = useState({
    borrower_id: 1,
    loan: 0,
  });

  const handleScroll = () => {
    setScrollPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo(0, 0);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const closeSidebar = () => {
    const sidebar = document.getElementById("offcanvasRight");
    const bsOffcanvas = window.bootstrap?.Offcanvas.getInstance(sidebar);
    if (bsOffcanvas) bsOffcanvas.hide();
  };

  // ✅ FIXED handleFormChange
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    if (name === "borrower_id") {
      const selected = borrowers.find((b) => b.id.toString() === value);
      setSelectedLoan(selected?.loan || "");

      // ✅ Update donationDetails properly
      setDonationDetails({
        borrower_id: selected?.id || "",
        loan: selected?.loan || 0,
      });
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // ✅ Autofill user info when modal opens
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setFormData((prev) => ({
        ...prev,
        name: user.name || "",
        email: user.email || "",
        contact: user.phone || "",
      }));
    }
  }, [showModal]);

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("email", formData.email);
    payload.append("contact", formData.contact);
    payload.append("city", formData.city);
    payload.append("country", formData.country);
    payload.append("payment_method", formData.payment_method || "stripe");
    payload.append("total", formData.total);
    payload.append("borrower_id", donationDetails.borrower_id);
    // payload.append("borrowers[0][loan]", donationDetails.loan);

    try {
      const response = await axiosInstance.post("/payment", payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("useToken")}`,
        },
      });

      const url = response?.data?.data;
      if (url) {
        toast.success("Redirecting to payment...");
        setShowModal(false);
        window.location.href = url;
      } else {
        toast.error("No payment URL returned.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      const errorMessage = error?.response?.data?.message || error.message;

      if (errorMessage === "Unauthenticated.") {
        toast.error("Please login first.");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        toast.error(errorMessage || "Something went wrong.");
      }
    }
  };

  return (
    <>
      <style>
        {`
        @media (max-width: 991.98px) {
          .Nav-main, .nav-content, .new-nav-content, .container {
            padding: 0 !important;
            margin: 0 !important;
            width: 100vw !important;
            min-width: 0 !important;
            max-width: 100vw !important;
          }
          .logo { width: 90px !important; height: auto !important; }
          .navbar-nav { flex-direction: column !important; align-items: flex-start !important; width: 100vw !important; background: white; padding: 10px 0; }
          .offcanvas { width: 90vw !important; min-width: 0 !important; max-width: 100vw !important; }
        }
        `}
      </style>
      <div className="container-fluid Nav-main bg-white position-fixed">
        <div className="top-split-bar">
          <div className="orange-bg-top"></div>
        </div>
        <div className="container nav-content new-nav-content">
          <nav className="navbar navbar-expand-lg align-items-center">
            {/* Left Main */}
            <div>
              <Link to={"/"}>
                <img
                  src="../images/logo11.png"
                  alt="Share Circle Logo"
                  className="logo"
                />
              </Link>
            </div>
            {/* Center Main */}
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav text-white">
                <li className="nav-item">
                  <Link
                    className={
                      location.pathname === "/"
                        ? "nav-link active-color"
                        : "nav-link"
                    }
                    aria-current="page"
                    to={"/"}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={
                      location.pathname === "/CSP"
                        ? "nav-link active-color"
                        : "nav-link"
                    }
                    aria-current="page"
                    to={"/CSP"}
                  >
                    Community Partner
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={
                      location.pathname === "/Entrepreneur"
                        ? "nav-link active-color"
                        : "nav-link"
                    }
                    to={"/Entrepreneur"}
                  >
                    Borrow
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={
                      location.pathname === "/Donate"
                        ? "nav-link active-color"
                        : "nav-link"
                    }
                    to={"/Donate"}
                  >
                    Donate
                  </Link>
                </li>
              </ul>
            </div>
            {/* Right Main - Desktop only */}
            <div className="Toggle d-none d-lg-flex gap-4 align-items-center">
              {token ? (
                <button
                  className="btn"
                  style={{
                    borderRadius: "25px",
                    padding: "10px 20px",
                    color: "red",
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              ) : (
                <Link
                  to="/login"
                  className="btn align-items-center"
                  style={{
                    borderRadius: "25px",
                    padding: "0",
                    paddingTop: "10px",
                    paddingLeft: "10px",
                  }}
                >
                  <button
                    type="button"
                    className="btn login"
                    style={{ color: "white", padding: "10px 20px" }}
                  >
                    Login
                  </button>
                </Link>
              )}
              <Link
                className="btn btn-outline-warning d-flex align-items-center"
                onClick={() => setShowModal(true)}
                style={{ borderRadius: "25px", padding: "3px 8px" }}
              >
                Donate Now
                <span className="arrow-icon">
                  <img
                    src="../images/arrowicon.png"
                    alt="not ok!"
                    className={"w-70"}
                  />
                </span>
              </Link>
            </div>
            {/* Hamburger - Mobile only */}
            <button
              type="button"
              className="btn btn-warning p-2 rounded-circle d-flex justify-content-center align-items-center d-lg-none"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
              style={{ width: "45px", height: "45px" }} // <-- paddingTop hata diya
            >
              <span style={{ fontSize: "1.5em", color: "white" }}>&#9776;</span>
            </button>
          </nav>
        </div>
        {/* Offcanvas - Mobile menu */}
        <div
          className="offcanvas offcanvas-end"
          style={{ backgroundColor: "gainsboro", width: "320px" }}
          tabIndex="-1"
          id="offcanvasRight"
          aria-labelledby="offcanvasRightLabel"
        >
          <div className="offcanvas-header">
            <NavLink
              to={"/"}
              id="offcanvasRightLabel"
              className="nav-link fw-bold"
            ></NavLink>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <div className="d-lg-none d-md-flex justify-content-center position-relative my-2">
              <input
                className="col-12 py-2"
                style={{
                  paddingLeft: "10px",
                  paddingRight: "5px",
                  border: "2px solid orange",
                  borderRadius: "8px",
                }}
              />
              <BiSearch
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  color: "orange",
                  fontSize: "25px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              />
            </div>
            <ul
              className="list-items11221"
              style={{
                listStyle: "none",
                textDecoration: "none",
                padding: "0px",
              }}
            >
              <li>
                <BiSolidMessageRoundedEdit
                  style={{
                    color: "orange",
                    marginRight: "14px",
                    fontSize: "30px",
                  }}
                />{" "}
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={closeSidebar}
                  to={"/"}
                >
                  Home
                </Link>
              </li>
              <li>
                <FaDonate
                  style={{
                    color: "orange",
                    marginRight: "20px",
                    fontSize: "30px",
                  }}
                />
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={closeSidebar}
                  to={"/CSP"}
                >
                  Community Partner
                </Link>
              </li>
              <li>
                <RiFundsBoxFill
                  style={{
                    color: "orange",
                    marginRight: "20px",
                    fontSize: "30px",
                  }}
                />
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to={"/Entrepreneur"}
                  onClick={closeSidebar}
                >
                  Borrow
                </Link>
              </li>
              <li>
                <MdOutlineRequestPage
                  style={{
                    color: "orange",
                    marginRight: "20px",
                    fontSize: "30px",
                  }}
                />
                <Link
                  style={{ textDecoration: "none", color: "black" }}
                  to={"/donate"}
                  onClick={closeSidebar}
                >
                  Donate
                </Link>
              </li>
              {/* Mobile only: Login/Logout */}
              <li className="mt-3 d-block d-lg-none" onClick={closeSidebar}>
                {token ? (
                  <button
                    className="btn w-100"
                    style={{
                      borderRadius: "25px",
                      color: "red",
                      fontWeight: 600,
                    }}
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                ) : (
                  <Link
                    to="/login"
                    className="btn login w-100"
                    style={{
                      borderRadius: "25px",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Login
                  </Link>
                )}
              </li>
            </ul>
          </div>
        </div>
        {/* Go to top button */}
        {scrollPosition > 500 ? (
          <button
            className="btn btn-sm p-2 rounded-circle position-fixed bottom-0 end-0 translate-middle"
            style={{ backgroundColor: "orange", color: "white" }}
            onClick={scrollToTop}
            id="back-to-up"
          >
            <AiOutlineArrowUp
              style={{ fontWeight: "bold" }}
              size={35}
              title="Go To Top"
            />
          </button>
        ) : null}
      </div>
      {/* Donate Today floating button */}
      <div
        style={{
          position: "fixed",
          top: "92vh",
          left: "30px",
          fontSize: "18px",
          fontWeight: "600",
          zIndex: "11233",
          width: "190px",
          color: "white",
          backgroundColor: "orange",
          padding: "8px",
          borderRadius: "10px",
        }}
      >
        <Link
          to={"/donate"}
          style={{ color: "white", textDecoration: "none" }}
          className="d-flex justify-content-center align-items-center gap-2"
        >
          <AiFillHeart /> Donate Today
        </Link>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Form onSubmit={handlePaymentSubmit}>
          <Modal.Header
            closeButton
            style={{ backgroundColor: "#e65c00" }}
            className="text-white"
          >
            <Modal.Title className="fw-bold">
              💖 Complete Your Donation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light text-dark px-4 py-3">
            <Form.Group controlId="formBorrower" className="mb-3">
              <Form.Label className="fw-semibold">Select Borrower</Form.Label>

              <Form.Select
                name="borrower_id"
                required
                className="border-dark shadow-sm text-dark"
                value={formData.borrower_id}
                onChange={handleFormChange}
              >
                <option value="">-- Select Borrower --</option>
                {Array.isArray(borrowers) && borrowers.length > 0 ? (
                  borrowers.map((b) => (
                    <option key={b.id} value={b.id}>
                      {b.name}
                    </option>
                  ))
                ) : (
                  <option disabled>No borrowers available</option>
                )}
              </Form.Select>

              {/* Show borrower's loan below dropdown */}
              {selectedLoan !== "" && (
                <div className="mt-2 text-success fw-semibold">
                  📌 Borrower's Loan Amount: ${selectedLoan}
                </div>
              )}
            </Form.Group>
            <Form.Group controlId="formName" className="mb-3">
              <Form.Label className="fw-semibold">Full Name</Form.Label>
              <Form.Control
                required
                type="text"
                name="name"
                placeholder="Enter your name"
                className="border-dark shadow-sm text-dark"
                value={formData.name}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formEmail" className="mb-3">
              <Form.Label className="fw-semibold">Email</Form.Label>
              <Form.Control
                required
                type="email"
                name="email"
                placeholder="Enter your email"
                className="border-dark shadow-sm text-dark"
                value={formData.email}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formContact" className="mb-3">
              <Form.Label className="fw-semibold">Contact Number</Form.Label>
              <Form.Control
                required
                type="text"
                name="contact"
                placeholder="03XX-XXXXXXX"
                className="border-dark shadow-sm text-dark"
                value={formData.contact}
                onChange={handleFormChange}
              />
            </Form.Group>

            <Form.Group controlId="formAmount" className="mb-3">
              <Form.Label className="fw-semibold">Donation Amount</Form.Label>
              <Form.Control
                required
                type="number"
                name="total"
                placeholder="Enter amount"
                className="border-dark shadow-sm text-dark"
                value={formData.total}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formCity" className="mb-3">
              <Form.Label className="fw-semibold">City</Form.Label>
              <Form.Control
                required
                type="text"
                name="city"
                placeholder="e.g., Lahore"
                className="border-dark shadow-sm text-dark"
                value={formData.city}
                onChange={handleFormChange}
              />
            </Form.Group>
            <Form.Group controlId="formCountry" className="mb-2">
              <Form.Label className="fw-semibold">Country</Form.Label>
              <Form.Select
                name="country"
                required
                className="border-dark shadow-sm text-dark"
                value={formData.country}
                onChange={handleFormChange}
              >
                <option value="">-- Select Country --</option>
                {countries.map((country, index) => (
                  <option key={index} value={country}>
                    {country}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="bg-light px-4 py-3">
            <Button
              variant="outline-secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button type="submit" variant="success" className="fw-bold">
              🚀 Proceed to Pay
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Header;
